import { h, Host } from "@stencil/core";
import { theme } from "@eventstore-ui/theme";
import { closest } from "@eventstore-ui/utils";
/**
 * A button.
 * @slot before - Placed before the main content with correct padding.
 * @slot after - Placed after the main content with correct padding.
 * @part button - The internal button element.
 * @part inner - The inner span, wrapping the default slot.
 */
export class Button {
    constructor() {
        this.variant = 'default';
        this.disabled = undefined;
        this.type = 'button';
    }
    handleKeyUp(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            this.host.dispatchEvent(new MouseEvent('click'));
        }
    }
    handleClick(e) {
        if (this.disabled) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
        if (this.type === 'submit') {
            const form = closest(this.host, 'form');
            if (form) {
                e.preventDefault();
                const fakeSubmit = document.createElement('button');
                fakeSubmit.type = 'submit';
                fakeSubmit.style.display = 'none';
                form.appendChild(fakeSubmit);
                fakeSubmit.click();
                fakeSubmit.remove();
            }
        }
    }
    connectedCallback() {
        if (this.host.hasAttribute('tabindex')) {
            this.tabindex = this.host.getAttribute('tabindex');
        }
    }
    render() {
        return (h(Host, { key: '2634772a7aaf1b3fc5c7289377f79fcebf0d9eb4', "high-contrast": theme.isHighContrast(), dark: theme.isDark() }, h("button", { key: 'd31f717a82c5e6c732f69767ccf40019a6398ea7', tabindex: this.tabindex, type: this.type, disabled: this.disabled, part: 'button' }, h("slot", { key: '37f32a2b0e6eb53b23f9d0f7d2ab80e23fe05dc3', name: 'before' }), h("span", { key: 'c46b0a240586f3dd24d1fd25635640525a48ffe1', part: 'inner' }, h("slot", { key: '7d8e090e03f52a6c4af09b1482d718afc29f43e3' })), h("slot", { key: '6ec6d2c994bd719150b8b15c147faefe32996bd7', name: 'after' }))));
    }
    static get is() { return "es-button"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["../button.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["../button.css"]
        };
    }
    static get properties() {
        return {
            "variant": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "ButtonVariant",
                    "resolved": "\"cancel\" | \"default\" | \"delete\" | \"filled\" | \"link\" | \"minimal\" | \"outline\"",
                    "references": {
                        "ButtonVariant": {
                            "location": "import",
                            "path": "../types",
                            "id": "src/components/buttons/types.ts::ButtonVariant"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Which styling variant to use."
                },
                "attribute": "variant",
                "reflect": true,
                "defaultValue": "'default'"
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "If the button is disabled. Prevents the user from interacting with the button: it cannot be pressed or focused."
                },
                "attribute": "disabled",
                "reflect": true
            },
            "type": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The default behavior of the button."
                },
                "attribute": "type",
                "reflect": false,
                "defaultValue": "'button'"
            }
        };
    }
    static get elementRef() { return "host"; }
    static get listeners() {
        return [{
                "name": "keyup",
                "method": "handleKeyUp",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "click",
                "method": "handleClick",
                "target": undefined,
                "capture": true,
                "passive": false
            }];
    }
}
//# sourceMappingURL=es-button.js.map
